// This script reorders the cart drawer footer elements
// when the cDiscount app is enabled, we need to have the elements in this order:
// 1. Discount container
// 2. Applied discounts
// 3. Checkout button


function reorderCartElements() {
    // Find the parent container where all elements are located
    const cartDrawer = document.querySelector('cart-drawer');
    const cartForm = cartDrawer.querySelector('form.buy-buttons.buy-buttons--compact');
    if (!cartForm) return;
  
    // Find the discount container - this is loaded by Shopify app
    const discountContainer = cartDrawer.querySelector('.scDiscount__container');
    if (!discountContainer) {
      // If discount container isn't loaded yet, retry after a short delay
      setTimeout(reorderCartElements, 500);
      return;
    }
  
    // Find the applied discounts section
    const appliedDiscounts = cartDrawer.querySelector('#cart-applied-discounts');
    
    // Find the checkout button
    const checkoutButton = cartDrawer.querySelector('button[name="checkout"]');
  
    if (!appliedDiscounts || !checkoutButton) {
        console.log('Cart elements not found');
        return;
    }
  
    // Clear the form and append elements in the desired order
    cartForm.innerHTML = '';
    cartForm.appendChild(discountContainer);
    cartForm.appendChild(appliedDiscounts);
    cartForm.appendChild(checkoutButton);

    console.log('Cart elements reordered');
}
  
// Start the reordering process when the page loads
document.addEventListener('DOMContentLoaded', reorderCartElements);

document.addEventListener('cart:refresh', () => {
    setTimeout(() => {
        reorderCartElements();
    }, 1000);
});
document.addEventListener('cart:change', () => {
    setTimeout(() => {
        reorderCartElements();
    }, 1000);
});
